export const constants = {
    filterType: {
        colors: "colors",
        select: "select",
        groupedselection: "groupedselection",
        selectiongroup: "selectiongroup",
        checkbox: "checkbox",
        checkboxes: "checkboxes",
        button: "buttons"
    },
    swatchStatus: {
        selected: "selected",
        remove: "remove"
    },
    background: {
        light: "light",
        dark: "dark"
    },
    gridColumns: {
        6: "col-6 col-md-3 col-lg-2",
        4: "col-6 col-md-4 col-lg-3"
    },
    resultsPerPage: 12
};
